import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions : {
    queries : {
      staleTime: 1000 * 60 * 5,
      refetchOnMount : false,
      refetchOnReconnect : false,
      refetchOnWindowFocus : false,
      retry: 1,
    }
  }
});